import { render, staticRenderFns } from "./DefaultContent.vue?vue&type=template&id=109950e4&"
import script from "./DefaultContent.vue?vue&type=script&lang=ts&"
export * from "./DefaultContent.vue?vue&type=script&lang=ts&"
import style0 from "./DefaultContent.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports